(() => {
  if (customElements.get('eb-blog-posts-carousel')) return;

  customElements.define('eb-blog-posts-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-blog-posts-track]');
      this.dots = [...this.querySelectorAll('[data-blog-posts-dot]')];
      if (!this.track) return;

      this.cards = [...this.track.children];
      this.active = 0;
      this.mq = window.matchMedia('(max-width: 768px)');
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.index, 10) || 0;
          this.scrollToCard(index);
        });
      });

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.mq.addEventListener('change', this.onResize);
      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.mq) this.mq.removeEventListener('change', this.onResize);
    }

    onResize() {
      this.update();
    }

    onScroll() {
      if (this.raf) return;
      this.raf = window.requestAnimationFrame(() => {
        this.raf = null;
        this.update();
      });
    }

    update() {
      const carouselOn = this.mq.matches;
      this.classList.toggle('is-carousel', carouselOn);

      if (!carouselOn) {
        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === 0));
        return;
      }

      const trackRect = this.track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let best = 0;
      let bestDistance = Infinity;

      this.cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });

      this.active = best;
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.active));
    }

    scrollToCard(index) {
      const card = this.cards[index];
      if (!card) return;
      const left = card.offsetLeft - (this.track.clientWidth - card.clientWidth) / 2;
      this.track.scrollTo({ left, behavior: 'smooth' });
    }
  });
})();
